import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { ApplicationStatusEnum, BriefApplicationResponseDto, StatusHistory } from '../../../../common/general-types/briefs.dto';
import { ApplicationStatusBadgeComponent } from '../../../../atoms/application-status-badge/application-status-badge.component';
import { MiscService } from '../../../../services/misc/misc.service';
import { DatePipe } from '@angular/common';
import { DeclineApplicationDrawerComponent } from '../../../../atoms/decline-application-drawer/decline-application-drawer.component';
import { canUnhireApplication } from '../../../admin-options/settings/molecules/brief-tracker/brief-tracker.helpers';
import { isShoutAgencyAdmin as hasShoutAgencyAdminRole } from '../../../../common/support-admin-roles.util';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'vs-status-history',
  standalone: true,
  imports: [ApplicationStatusBadgeComponent, DatePipe, DeclineApplicationDrawerComponent],
  templateUrl: './status-history.component.html',
  styleUrl: './status-history.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StatusHistoryComponent {

  @ViewChild('statusHistoryDrawerDialog', { static: false }) statusHistoryDrawerDialog?: ElementRef<HTMLDialogElement>;
  @ViewChild('statusHistoryDrawerButton', { static: false }) statusHistoryDrawerButton?: ElementRef<HTMLButtonElement>;

  @Input() applicationStatus: ApplicationStatusEnum | undefined;
  @Input() statusHistory: StatusHistory[] | undefined;
  @Input() selectedApplication: BriefApplicationResponseDto | undefined;

  @Output() close = new EventEmitter<void>();

  readonly canUnhireApplication = canUnhireApplication;

  /** Services */
  public miscService = inject(MiscService);
  private readonly authService = inject(AuthService);
  /** Services - END */

  get isShoutAgencyAdmin(): boolean {
    return hasShoutAgencyAdminRole(this.authService.userRoles);
  }

  closeDrawer() {
    this.statusHistoryDrawerDialog?.nativeElement.close();
    this.close.emit();
  }
}
